import { useState, useEffect } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card, Table, Pagination } from "react-bootstrap";

import _ from "lodash";
import axios from "axios";
import Utils from "../../common/Utils";

const AddJobs = (props) => {
  const [data, setData] = useState({ role: props.role, depts: [], jcats: [], jobs: [], load: false });
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selected, setSelected] = useState([]);
  const [filter, setFilter] = useState({ dept: "", jcat: "", job: "" });
  const [dept, setDept] = useState("");
  const [pager, myPager] = useState({ perpage: 200, start: 0, total: 0 });

  const fetchRoleProps = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl(`users/fetchmyprops?props=depts,jcats`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setData({ ...data, depts: _.get(res, "data.depts", []), jcats: _.get(res, "data.jcats", []) });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  useEffect(fetchRoleProps, []);

  const fetchJobs = () => {
    if (!data.load) return;
    setLoading(true);
    setSelectAll(false);
    setSelected([]);
    let params = `role=${data.role.id}&dept=${filter.dept}&jcat=${filter.jcat}&job=${filter.job}&start=${pager.start}&perpage=${pager.perpage}`;
    axios
      .get(Utils.apiUrl(`users/fetchjobstoadd?${params}`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          let tmp = { jobs: _.get(res, "data.jobs", []) };

          if (pager.start === 0) {
            tmp["total"] = res.data.total;
          }
          setData({ ...data, ...tmp });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  const setPager = ({ start, perpage }) => {
    if (data.load === false) {
      setData({ ...data, load: true });
    }
    myPager({ ...pager, start: start, perpage: perpage });
  };

  const doSearch = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    setFilter({
      dept: frm.dept.value,
      jcat: frm.jcat.value,
      job: frm.job.value,
    });
    setPager({ ...pager, start: 0 });
  };

  useEffect(fetchJobs, [pager]);

  const renderPagination = () => {
    return (
      <Row>
        <Col>
          <Button variant="success" disabled={selected.length === 0} onClick={addJobs}>
            Add Selected Jobs
          </Button>
        </Col>
        <Col>
          <div className="d-flex justify-content-end">
            <Pagination>
              <div className="mt-2 me-2">Perpage:</div>
              <select
                className="form-select mb-3 me-5"
                style={{ width: "80px" }}
                onChange={(e) => setPager({ ...pager, start: 0, perpage: parseInt(e.currentTarget.value) })}
              >
                {[10, 25, 50, 100, 200].map((p) => (
                  <option value={p} key={p} selected={p === pager.perpage}>
                    {p}
                  </option>
                ))}
              </select>
              <Pagination.First onClick={(e) => setPager({ ...pager, start: 0 })} disabled={pager.start === 0} />
              <Pagination.Prev onClick={(e) => setPager({ ...pager, start: pager.start - pager.perpage })} disabled={pager.start === 0} />
              <select
                className="form-select mb-3 mx-1"
                style={{ width: "80px" }}
                onChange={(e) => setPager({ ...pager, start: parseInt(e.currentTarget.value) * pager.perpage })}
              >
                {new Array(Math.ceil(data.total / pager.perpage)).fill(0).map((v, p) => (
                  <option key={p} value={p} selected={p === pager.start / pager.perpage}>
                    {p + 1}
                  </option>
                ))}
              </select>
              <Pagination.Next
                onClick={(e) => setPager({ ...pager, start: pager.start + pager.perpage })}
                disabled={pager.start >= data.total - pager.perpage}
              />
              <Pagination.Last
                onClick={(e) => setPager({ ...pager, start: (Math.ceil(data.total / pager.perpage) - 1) * pager.perpage })}
                disabled={pager.start >= data.total - pager.perpage}
              />
            </Pagination>
          </div>
        </Col>
      </Row>
    );
  };

  const toggleCheck = (e, jid) => {
    if (e.currentTarget.checked) {
      setSelected([...selected, jid]);
    } else {
      setSelected(_.filter(selected, (id) => id !== jid));
    }
  };

  const toggleCheckAll = () => {
    if (selectAll) {
      setSelected(data.jobs.map((j) => j.id));
    } else {
      setSelected([]);
    }
  };

  useEffect(toggleCheckAll, [selectAll]);

  const addJobs = () => {
    setLoading(true);
    axios
      .post(Utils.apiUrl(`users/addjobstorole`), `rid=${data.role.id}&jids=${selected.join(",")}`, Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          window.alert(res.data.message);
          fetchJobs();
          props.afterSave();
        }
      })
      .catch((err) => {
        setLoading(false);
        window.alert(_.isObject(err.message) ? Object.values(err.message).join(",") : err.message);
        console.log(err);
      });
  };

  return (
    <Modal show={true} dialogClassName="modal-fullscreen" onHide={props.onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Add Jobs to Role {data.role.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={doSearch} className="mb-4">
          <Row>
            <Col>
              <Form.Label>By Department: </Form.Label>
              <select name="dept" className="form-select" onChange={(e) => setDept(e.currentTarget.value)}>
                <option value="">All Departments</option>
                {data.depts.length > 0 &&
                  data.depts.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
              </select>
            </Col>
            <Col>
              <Form.Label>By Job Category: </Form.Label>
              <select name="jcat" className="form-select">
                <option value="">All Job Categories</option>
                {data.jcats.length > 0 &&
                  _.filter(data.jcats, (j) => parseInt(j.department_id) === parseInt(dept)).map((j) => (
                    <option key={j.id} value={j.id}>
                      {j.name}
                    </option>
                  ))}
              </select>
            </Col>
            <Col>
              <Form.Label>By Job: </Form.Label>
              <Form.Control name="job" />
            </Col>
            <Col>
              <Button type="submit" variant="info" style={{ marginTop: "27px" }}>
                Search
              </Button>
            </Col>
          </Row>
        </Form>
        <div className="my-2">
          {loading && (
            <Alert variant="warning" className="p-5 text-center">
              Fetching Job list..
            </Alert>
          )}
          {!loading && (
            <>
              {data.jobs.length === 0 && (
                <Alert variant="warning" className="p-5 text-center">
                  Select/Apply filters to fetch the job list.
                </Alert>
              )}
              {data.jobs.length > 0 && (
                <>
                  {renderPagination()}
                  <Table striped={true}>
                    <thead>
                      <tr>
                        <th style={{ width: "40px" }} className="text-center">
                          <input type="checkbox" defaultChecked={selectAll} onChange={(e) => setSelectAll(e.currentTarget.checked)} />
                        </th>
                        <th style={{ width: "80px" }}>Sl.</th>
                        <th>Job</th>
                        <th>Occurence</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.jobs.map((j, idx) => (
                        <tr>
                          <td className="text-center">
                            <input type="checkbox" checked={selected.includes(j.id)} onChange={(e) => toggleCheck(e, j.id)} />
                          </td>
                          <td>{pager.start + idx + 1}</td>
                          <td>{j.name}</td>
                          <td>
                            {j.occurence}
                            {j.occurence === "periodic" && <> - {j.occ_every_x_day === "1" ? "daily" : j.occ_every_x_day + " days"}</>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {renderPagination()}
                </>
              )}
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddJobs;
